import BaseModel from "../base/baseModel";

export default class MotivoEtapaPCPModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
}
